<div class="middleContent">
    <section class="mt-131">
        <div class="container-fluid px-2">
            <div class="row justify-content-center">
                <div class="col-md-6">
                    <div class="card border-0 stepsBars-2">
                        <div class="card-body">
                            <div class="main mx-0 pb-1 text-center">
                                <img src="images/access_denied.jpg" alt="" width="300px">
                                <h1 class="access_deniedText">We are sorry...</h1>
                                <p class="fs-13">Seems like you do not have access to the this page.<br> Please refer to your system administrator.</p>
                                <!-- <button class="btn progressBtn ps-2 mb-3" role="button">
                                    GO TO SYSTEM ADMINISTATOR
                                </button> -->
                            </div>


                        </div>
                    </div>


                </div>
            </div>
        </div>
    </section>



</div>